import * as React from 'react';
import { Container } from 'vendors/semantic-ui';

import {
    CarrouselVisuels,
    getNestedReferenceId,
    MentionContainer,
    TitleBloc,
    TitleBlocProps,
} from 'modules/shared-cms-advanced';
import { extractCMSOrDefault, getDefault } from 'modules/shared-cms/utils';
import { TextContentBlock } from 'modules/listes/modules/creation-liste/components/cms';
import { RegistrationForm } from './registration-form';

import { VoyagePageProps } from './voyage.types';
import { Enhancer } from './voyage.enhancer';

import styles from './voyage.module.css';

export const page: React.FC<VoyagePageProps> = (props: VoyagePageProps) => {
    const {
        textContentBlock1 = {
            color: props.tcb1BackgroundColor,
            textColor: props.tcb1TextColor,
            title: props.tcb1Title,
            fontSizeTitle: props.tcb1FontSizeTitle,
            subTitle: props.tcb1Subtitle,
            fontSizeSubTitle: props.tcb1FontSizeSubtitle,
            ctaText1: props.tcb1CtaText1,
            ctaLink1: props.tcb1CtaLink1,
            ctaStyle1: props.tcb1CtaStyle1,
            ctaText2: props.tcb1CtaText2,
            ctaLink2: props.tcb1CtaLink2,
            ctaStyle2: props.tcb1CtaStyle2,
            ctaText3: props.tcb1CtaText3,
            ctaLink3: props.tcb1CtaLink3,
            ctaStyle3: props.tcb1CtaStyle3,
        },
        carrouselVisuels1 = getDefault(getNestedReferenceId(props.carrouselVisuels1), ''),
        textContentBlock2 = {
            color: props.tcb2BackgroundColor,
            textColor: props.tcb2TextColor,
            title: props.tcb2Title,
            fontSizeTitle: props.tcb2FontSizeTitle,
            subTitle: props.tcb2Subtitle,
            fontSizeSubTitle: props.tcb2FontSizeSubtitle,
            ctaText1: props.tcb2CtaText1,
            ctaLink1: props.tcb2CtaLink1,
            ctaStyle1: props.tcb2CtaStyle1,
            ctaText2: props.tcb2CtaText2,
            ctaLink2: props.tcb2CtaLink2,
            ctaStyle2: props.tcb2CtaStyle2,
            ctaText3: props.tcb2CtaText3,
            ctaLink3: props.tcb2CtaLink3,
            ctaStyle3: props.tcb2CtaStyle3,
        },
        formMentions = extractCMSOrDefault(props.formMentions, ''),
        carrouselVisuels2 = getDefault(getNestedReferenceId(props.carrouselVisuels2), ''),
        mentions = extractCMSOrDefault(props.mentions, ''),
    } = {};

    return (
        <>
            <TitleBloc {...(props as TitleBlocProps)} />
            <Container>
                <TextContentBlock
                    rootClassName={styles.tcbRoot}
                    contentclassName={styles.tcbContent}
                    titleClassName={styles.tcbTitle}
                    {...textContentBlock1}
                />

                <div className={styles.registrationForm}>
                    <RegistrationForm />
                </div>
                {formMentions !== '' && (
                    <div className={styles.formMentions}>
                        <MentionContainer mention={formMentions} mentionFontSize={10} mentionTextColor="#000000" />
                    </div>
                )}
                {carrouselVisuels1 !== '' && <CarrouselVisuels id={carrouselVisuels1} />}
                <TextContentBlock
                    rootClassName={styles.tcb2Root}
                    contentclassName={styles.tcbContent}
                    titleClassName={styles.tcbTitle}
                    {...textContentBlock2}
                />
                {carrouselVisuels2 !== '' && <CarrouselVisuels id={carrouselVisuels2} />}
                {mentions !== '' && (
                    <div className={styles.mentions}>
                        <MentionContainer mention={mentions} mentionFontSize={10} mentionTextColor="#000000" />
                    </div>
                )}
            </Container>
        </>
    );
};

export const VoyagePage = Enhancer(page);
